"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCellDropdown = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * TableCellDropdown Component
 * @extends {React.Component}
 */
var TableCellDropdown = function TableCellDropdown(_ref) {
  var className = _ref.className,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    value = _ref.value,
    id = _ref.id,
    dataTestId = _ref['data-testid'];
  var dropdownCellRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];

  /**
   * Toggles dropdown if a click is detected inside dropdown.
   * @param {Object} e Synthetic event
   */
  var handleClick = function handleClick(e) {
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };
  var open = Boolean(anchorEl);
  var listItems = /*#__PURE__*/_react["default"].createElement(_core.Popper, {
    className: "".concat(className, " card-menu"),
    open: open,
    disablePortal: true,
    placement: "bottom-start",
    anchorEl: dropdownCellRef.current
  }, /*#__PURE__*/_react["default"].createElement(_core.Grow, {
    "in": open
  }, /*#__PURE__*/_react["default"].createElement(_core.Paper, {
    elevation: 8
  }, /*#__PURE__*/_react["default"].createElement(_core.MenuList, {
    className: className
  }, options.map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      className: "".concat(className, " menu-item"),
      key: i,
      onClick: function onClick(e) {
        handleClick(e);
        onChange(option, id);
      }
    }, option.label);
  })))));
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    className: className,
    ref: dropdownCellRef
  }, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    className: "".concat(className, " dropdown"),
    variant: "standard",
    value: value,
    onClick: handleClick,
    inputProps: {
      disabled: true
    },
    InputProps: {
      disableUnderline: true,
      className: 'field-modifier',
      endAdornment: /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
        position: "end",
        className: className
      }, open ? /*#__PURE__*/_react["default"].createElement(_icons.ArrowDropUp, {
        className: "".concat(className, " arrow-up")
      }) : /*#__PURE__*/_react["default"].createElement(_icons.ArrowDropDown, {
        className: "".concat(className, " arrow-down")
      }))
    },
    "data-testid": dataTestId
  }), listItems);
};
exports.TableCellDropdown = TableCellDropdown;